<template>
	<div class="ir-module-block">
		<MStateBox :loading="question.loading" :empty="emptyNews">
			<CCardQAPanel
				v-for="(item, index) in displayQuestionData"
				:key="index"
				:item="item"
				ellipsis
				@click="gotDetails(item)"
			></CCardQAPanel>
			<slot name="footer"></slot>
		</MStateBox>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import CCardQAPanel from '@rebuild/components/CCardQaPanel.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useNavigation } from '@rebuild/hooks/useNavigation';

const { question } = useModuleData();
const emptyNews = computed(() => {
	const { data, empty } = question;
	return empty || !data?.rows?.length;
});

const displayQuestionData = computed(() => {
	const data = question.data?.rows || [];
	// 展示最新的
	return data?.slice(0, 3);
});

const refresh = async done => {
	await question.refresh({
		pagestart: 0,
		pagenum: 20
	});
	done && done();
};

onMounted(() => {
	refresh();
});
const { goToModule } = useNavigation();
const gotDetails = () => {
	goToModule('question');
};
</script>

<style lang="less" scoped></style>
